import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IAppTitleProps } from './AppTitle.interface';

export const AppTitle: FunctionComponent<IAppTitleProps> = (props) => {
  const { title, logo } = props;

  return (
    <Stack
      direction={'row'}
      spacing={2}
      sx={{
        alignItems: 'center',
        marginRight: 4,
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}>
        {logo}
      </Box>
      <Box>
        <Typography variant={'button'}>
          {title}
        </Typography>
      </Box>
    </Stack>
  );
};
